module.exports = __webpack_public_path__ + "media/images/icons/material/not-sent-96c81852f0ef59f5952bee06f15c856b.svg";